import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import axios from "axios";
import Dropzone from "react-dropzone";
import lodash from "lodash";
import ActiveSelect from "../../general/ActiveSelect.js";
import Loading from "../../general/Loading.js";
import LocationSelect from "../../general/LocationSelect.js";
import Search from "../../general/Search.js";
import DateTd from "../../table-componets/DateTd.js";
import LinkTd from "../../table-componets/LinkTd.js";
import NewSaiCertificationModal from "../NewSaiCertificationModal/NewSaiCertificationModal.js";
import CertificationTypeCodeSelect from "./CertificationTypeCodeSelect.js";
import CertificationRangeSelect from "../CertificationRangeSelect.js";
import ProgramDirectorSelect from "../ProgramDirectorSelect.js";
import InstructorTrainerSelect from "../InstructorTrainerSelect.js";
import TrainingCenterSelect from "../TrainingCenterSelect.js";
import SaiCertificationsIndex from "../SaiIndex/SaiCertificationsIndex.jsx";
import SaiActions from "./SaiActions";

class SaiAdminPortal extends React.Component {
  state = {
    selectedLocationId: "",
    searchText: "",
    certificationRange: "",
    certificationType: "",
    active: 1,
    page: 1,
    perPage: 25,
    totalPages: 1,
    orderBy: "users-last_name",
    orderDir: "ASC",
    selectedCertification: {},
    selectedCertificationType: {},
    selectedCertificationUser: {},
    certifications: [],
    loading: true,
    certificationTypes: this.props.certification_types,
    saiCertificationGroupsTypesSteps: this.props.saiCertificationGroupsTypesSteps
  };

  componentDidMount() {
    this.buildData();
  }

  newLocation(newLocation) {
    this.setState({
      loading: true,
      selectedLocationId: newLocation,
      page: 1
    });
    this.buildData();
  }

  newProgramDirector(newProgramDirector) {
    this.setState({
      loading: true,
      selectedProgramDirector: newProgramDirector,
      page: 1
    });
    this.buildData();
  }

  newInstructorTrainer(newInstructorTrainer) {
    this.setState({
      loading: true,
      selectedInstructorTrainer: newInstructorTrainer,
      page: 1
    });
    this.buildData();
  }

  newTrainingCenter(newTrainingCenter) {
    this.setState({
      loading: true,
      selectedTrainingCenter: newTrainingCenter,
      page: 1
    });
    this.buildData();
  }

  newSearch(newSearch) {
    this.setState({
      loading: true,
      searchText: newSearch,
      page: 1
    });
    this.buildData();
  }

  newCertificationRange(newCertificationRange) {
    this.setState({
      loading: true,
      certificationRange: newCertificationRange,
      page: 1
    });
    this.buildData();
  }

  newCertificationType(newCertificationType) {
    this.setState({
      loading: true,
      certificationType: newCertificationType,
      page: 1
    });
    this.buildData();
  }

  newActive(newActive) {
    if (newActive == "true") {
      var active = 1;
    } else if (newActive == "false") {
      var active = 0;
    } else {
      var active = null;
    }

    this.setState({
      loading: true,
      active: active,
      page: 1
    });
    this.buildData();
  }

  changePage(increment) {
    var page = this.state.page + increment;
    this.setState({ page: page });
    setTimeout(
      function() {
        this.buildData();
      }.bind(this),
      50
    );
  }

  saveCertification() {
    var that = this;

    var formData = new FormData();

    formData.append(
      "certification[expiration_date]",
      that.state.expirationDate
    );

    formData.append(
      "certification[provider_certification_id]",
      that.state.providerCertificationId
    );

    if (that.state.issueDate) {
      formData.append(
        "certification[issue_date]",
        that.state.issueDate
      );
    }

    if (that.state.uploadedFile.preview) {
      formData.append(
        "certification[attachment]",
        that.state.uploadedFile
      );
    }

    var config = {
      headers: { "content-type": "multipart/form-data" }
    };

    axios
      .put(
        "/certifications/" + that.state.selectedCertification.id,
        formData,
        config
      )
      .then(function(response) {
        var certifications = that.state.certifications;
        certifications[that.state.selectedCertification.index] = response.data;
        that.setState({ certifications: certifications });

        $("#editCertificationModal").modal("hide");

        var issueDatePicker = $("#editIssueDatePicker").data("kendoDatePicker");
        issueDatePicker.value(null);

        var expirationDatePicker = $("#editExpirationDatePicker").data(
          "kendoDatePicker"
        );
        expirationDatePicker.value(null);

        that.setState({
          uploadedFile: []
        });

        toastr.success("Certification updated");
      })
      .catch(function(error) {
        toastr.error("Certification not updated");
        console.log(error);
      });
  }

  render() {
    const { certificationTypes, saiCertificationGroupsTypesSteps } = this.state;

    var that = this;

    return (
      <div>
        <h1>SAI Admin Portal</h1>
        <div className="row">
          <LocationSelect
            locationId={this.props.locationId}
            locations={this.props.locations}
            selectClassName="col-md-3 col-xs-12"
            newLocationCallback={newLocation => this.newLocation(newLocation)}
          />
          <Search newSearchCallback={newSearch => this.newSearch(newSearch)} />
          <div className="col-md-6 pull-right">
            <SaiActions
              locationId={this.state.selectedLocationId}
              active={this.state.active || ""}
              saiAdminPortal={true}
            />
          </div>
        </div>
        <div className="row">
          <CertificationTypeCodeSelect
            certificationTypes={certificationTypes}
            newCertificationTypeCallback={newCertificationType =>
              this.newCertificationType(newCertificationType)
            }
          />
          <CertificationRangeSelect
            newCertificationRangeCallback={newCertificationRange =>
              this.newCertificationRange(newCertificationRange)
            }
          />
          <ActiveSelect
            newActiveCallback={newActive => this.newActive(newActive)}
          />
        </div>
        <div className="row">
          <ProgramDirectorSelect
            programDirectorId={0}
            programDirectors={this.props.programDirectors}
            selectClassName="col-md-3 col-xs-12"
            newProgramDirectorCallback={newProgramDirector => this.newProgramDirector(newProgramDirector)}
            isSaiAdmin={this.props.isSaiAdmin}
          />
          <InstructorTrainerSelect
            instructorTrainerId={0}
            instructorTrainers={this.props.instructorTrainers}
            selectClassName="col-md-3 col-xs-12"
            newInstructorTrainerCallback={newInstructorTrainer => this.newInstructorTrainer(newInstructorTrainer)}
            isSaiAdmin={this.props.isSaiAdmin}
          />
          <TrainingCenterSelect
            trainingCenterId={0}
            trainingCenters={this.props.trainingCenters}
            selectClassName="col-md-3 col-xs-12"
            newTrainingCenterCallback={newTrainingCenter => this.newTrainingCenter(newTrainingCenter)}
            isSaiAdmin={this.props.isSaiAdmin}
          />
        </div>
        <br />
        {this.state.certifications.length ? (
          <div>
            <SaiCertificationsIndex
              certifications={this.state.certifications}
              handlerDelete={this.handlerDelete}
              openEditModal={this.openEditModal}
              sortData={this.sortData}
              programDirectors={this.props.programDirectors}
              instructorTrainers={this.props.instructorTrainers}
              trainingCenters={this.props.trainingCenters}
              updateCertificationStepResult={this.updateCertificationStepResult}
              isSaiAdmin={this.props.isSaiAdmin}
            />
          <div>
              <p>
                {"Showing page " + this.state.page + " of " + this.state.totalPages}
              </p>
              {this.state.page == 1 && (
                <a className="btn btn-default disabled">
                  <i className="material-icons progress-bar-icon">
                    keyboard_arrow_left
                  </i>
                </a>
              )}
              {this.state.page != 1 && (
                <a className="btn btn-default" onClick={() => this.changePage(-1)}>
                  <i className="material-icons progress-bar-icon">
                    keyboard_arrow_left
                  </i>
                </a>
              )}
              {this.state.page < this.state.totalPages && (
                <a className="btn btn-default" onClick={() => this.changePage(1)}>
                  <i className="material-icons progress-bar-icon">
                    keyboard_arrow_right
                  </i>
                </a>
              )}
              {this.state.page == this.state.totalPages && (
                <a className="btn btn-default disabled">
                  <i className="material-icons progress-bar-icon">
                    keyboard_arrow_right
                  </i>
                </a>
              )}
            </div>
          </div>
        ) : (
          <Loading
            loading={this.state.loading}
            noDataMessage="No certifications"
          />
        )}

        <NewSaiCertificationModal
          saiCertificationGroupsTypesSteps={saiCertificationGroupsTypesSteps}
          programDirectors={this.props.programDirectors}
          instructorTrainers={this.props.instructorTrainers}
          trainingCenters={this.props.trainingCenters}
          employees={this.props.employees}
          onAdded={this.handlerCertificationAdded}
          isSaiAdmin={this.props.isSaiAdmin}
        />
      </div>
    );
  }

  updateCertificationStepResult = (certification, stepResult, index) => {
    var certifications = this.state.certifications;
    certifications[index].expiration_date = certification.expiration_date;
    certifications[index]["latest_certification_step_result"] = stepResult;
    this.setState({certifications: certifications});
  };

  handlerCertificationTypeAdded = data => {
    const tmp = this.state.certificationTypes;
    tmp.push(data);
    this.setState({ certificationTypes: tmp });
  };

  handlerCertificationAdded = data => {
    toastr.success("Certification created");
    this.buildData();
  };

  handlerDelete = certification => {
    var that = this;

    if (!confirm("Are you sure you want to delete this certification?")) {
      return;
    }

    if (this.props.accountIsSai) {
      axios.delete(`/certifications/${certification.id}`).then(
        function(response) {
          toastr.error("Certification deleted");
          that.buildData();
        }
      );
    } else {
      const certifications = this.state.certifications;
      lodash.remove(certifications, { id: certification.id });
      this.setState({ certifications: certifications });

      toastr.error("Certification deleted");

      axios.delete(`/certifications/${certification.id}`)
    };
  };

  openEditModal = (certification, index) => {
    var that = this;

    var certifications = this.state.certifications;

    if (certification.issue_date) {
      var issueDate = moment(certification.issue_date).format();
    } else {
      var issueDate = null;
    }

    $("#editIssueDatePicker").kendoDatePicker({
      value: issueDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          issueDate: value
        });
      }
    });

    $("#editExpirationDatePicker").kendoDatePicker({
      value: moment(certification.expiration_date).format(),

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          expirationDate: value
        });
      }
    });

    certification.index = index;

    this.setState({ selectedCertification: certification });
    this.setState({
      selectedCertificationType: certification.certification_type
    });
    this.setState({ selectedCertificationUser: certification.user });
    this.setState({ issueDate: certification.issue_date });
    this.setState({ expirationDate: certification.expiration_date });
    this.setState({
      providerCertificationId: certification.provider_certification_id
    });

    $("#editCertificationModal").modal("show");
  }

  sortData = (orderBy) => {
    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == "DESC") {
        this.setState({ orderDir: "ASC" });
      } else {
        this.setState({ orderDir: "DESC" });
      }
    } else {
      this.setState({ orderBy: orderBy });
      this.setState({ orderDir: "DESC" });
    }

    setTimeout(
      function() {
        this.buildData();
      }.bind(this),
      50
    );
  }

  buildData= () => {
    var that = this;

    var params = {
      page: this.state.page,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.orderDir
    };

    if (this.state.selectedLocationId) {
      params["location_id"] = this.state.selectedLocationId;
    }

    if (this.state.searchText) {
      params["search"] = this.state.searchText;
    }

    if (this.state.certificationRange) {
      params["certification_range"] = this.state.certificationRange;
    }

    if (this.state.certificationType) {
      params["certification_type_code"] = this.state.certificationType;
    }

    if (this.state.active != null) {
      params["active"] = this.state.active;
    }

    if (this.state.selectedProgramDirector) {
      params["program_director_id"] = this.state.selectedProgramDirector;
    }

    if (this.state.selectedInstructorTrainer) {
      params["instructor_trainer_id"] = this.state.selectedInstructorTrainer;
    }

    if (this.state.selectedTrainingCenter) {
      params["training_center_id"] = this.state.selectedTrainingCenter;
    }

    params["sai_only"] = true;

    axios({
      method: "get",
      url: "/sai_admin_portal.json",
      params: params,
      responseType: "json"
    }).then(function(response) {
      that.setState({
        loading: false,
        certifications: response.data,
        totalPages: Math.ceil(response.headers.total / that.state.perPage)
      });
    });
  }
}

SaiAdminPortal.propTypes = {
  certification_types: PropTypes.array,
  locations: PropTypes.array,
  saiCertificationGroupsTypesSteps: PropTypes.array,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  employees: PropTypes.array,
  isSaiAdmin: PropTypes.bool
};

export default SaiAdminPortal;
